module.exports = __webpack_public_path__ + "img/Icon__province_5.d13b30ee.svg";